import(/* webpackMode: "eager" */ "E:\\Claude_Code_Projects\\PERSONA\\persona-platform\\apps\\client\\web\\src\\app\\(public)\\staking\\page.tsx");
